export default {
    // dev server
    SERVER_URL: 'https://interface.recycletek.ddns.net',
    // local server
    // SERVER_URL: "http://localhost:5001",
    //SERVER_URL: "https://interface.recycletek.co"
};

